import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Card from "../../../common/element/Card";
import Heading from "../../../common/element/Heading";
import BtnPrimary from "../../../common/element/Buttons/btnPrimary";
import { Link } from "react-router-dom";
import ThreeDotLoader from "../../../common/element/ButtonLoader/ThreeDotLoader";
import Validations from "../../../common/404/Validations";
import Loader from "../../../common/loader";
import { login } from "../../../redux/auth/authSlice";
import { selectLoginLoading, selectLoginError, selectUserData } from "../../../redux/auth/authSelector";

// ✅ Imported the profile API action
import { getAdminProfile } from "../../../redux/Setting/Settingsslice";

const logoImage = "/assets/images/Logo-Incredible-Leaders.png";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hiddenpassword: true,
      login_form: {
        email: {
          type: "email",
          label: "Email",
          placeholder: "Enter your email address",
          valid: true,
          error_msg: "",
          value: "",
          Validations: { required: true, email: true },
        },
        password: {
          type: "password",
          label: "password",
          placeholder: "Enter your password",
          valid: true,
          error_msg: "",
          value: "",
          Validations: { required: true, min_lenght: 8, password: true },
        },
        remember: {
          type: "checkbox",
          label: "remember",
          placeholder: "Remember for 30 days",
          valid: true,
          error_msg: "",
          value: "",
          isChecked: false,
          Validations: { required: false },
        },
      },
      isLoadingDots: false,
      error: "",
    };
  }

  componentDidMount() {
    // Load remember me data if exists
    const rememberUser = localStorage.getItem("rememberUser");
    const rememberEmail = localStorage.getItem("rememberEmail");
    const rememberPassword = localStorage.getItem("rememberPassword");

    if (rememberUser === "true" && rememberEmail && rememberPassword) {
      const update_login_form = { ...this.state.login_form };
      update_login_form.remember.isChecked = true;
      update_login_form.email.value = rememberEmail;
      update_login_form.password.value = rememberPassword;
      this.setState({ login_form: update_login_form });
    }
  }

  componentDidUpdate(prevProps) {
    // ✅ Check if UserData was just updated after login
    if (!prevProps.UserData && this.props.UserData) {
      console.log("UserData updated in Redux:", this.props.UserData);
      console.log("Role Name from Redux:", this.props.UserData.role_name);
    }
  }

  togglePassword = () => {
    this.setState({ hiddenpassword: !this.state.hiddenpassword });
  };

  inputChangeHandler = (e, identifier) => {
    const update_login_form = { ...this.state.login_form };
    const form_element = { ...update_login_form[identifier] };

    if (identifier === "remember") {
      form_element.isChecked = e.target.checked;
      form_element.value = e.target.value;
    } else {
      form_element.value = e.target.value;
    }

    // Validate element
    let validate_element = Validations(form_element);
    form_element.valid = validate_element.valid;

    update_login_form[identifier] = form_element;
    
    let is_form_valid = true;
    for (let identifier in update_login_form) {
      is_form_valid = update_login_form[identifier].valid && is_form_valid;
    }

    this.setState({
      login_form: update_login_form,
      is_form_valid: is_form_valid,
    });
  };

  loginSubmitHandler = async (event) => {
    event.preventDefault();
    let is_form_valid = true;
    const update_login_form = { ...this.state.login_form };

    // Validate all fields
    for (let key in update_login_form) {
      let form_element = update_login_form[key];
      let validate_element = Validations(form_element);

      is_form_valid = validate_element.valid === false ? false : is_form_valid;
      form_element.valid = validate_element.valid;
      form_element.error_msg = validate_element.error_msg;

      update_login_form[key] = form_element;
    }
    this.setState({ login_form: update_login_form });

    if (is_form_valid) {
      const email = this.state.login_form.email.value;
      const password = this.state.login_form.password.value;
      const remember = this.state.login_form.remember.isChecked;

      const form_data = {
        email: email,
        password: password,
      };

      this.setState({ isLoadingDots: true, error: "" });

      try {
        // ✅ Call Redux login action
        const resultAction = await this.props.dispatch(login(form_data));

        console.log("Result Action:", resultAction);

        // ✅ Check if login was successful
        if (login.fulfilled.match(resultAction)) {
          const response = resultAction.payload;
          
          console.log("✅ Login Successful!");
          console.log("Response payload:", response);
          console.log("Role Name from response:", response?.role_name);

          // ✅ Store token in localStorage
          if (response?.token) {
            localStorage.setItem("auth_token", response.token);
          }

          // ✅ Store user data in localStorage for session persistence
          localStorage.setItem("user_data", JSON.stringify(response));

          // ✅ Fetch User Profile Data IMMEDIATELY after getting the token
          try {
            console.log("Fetching User Profile Data...");
            await this.props.dispatch(getAdminProfile());
          } catch (profileError) {
            console.error("❌ Failed to fetch profile after login:", profileError);
          }

          // ✅ Handle remember me
          if (remember) {
            localStorage.setItem("rememberUser", "true");
            localStorage.setItem("rememberEmail", email);
            localStorage.setItem("rememberPassword", password);
          } else {
            localStorage.removeItem("rememberUser");
            localStorage.removeItem("rememberEmail");
            localStorage.removeItem("rememberPassword");
          }


          // Import DEFAULT_ROUTES at the top if not already
          // import { ROLES, DEFAULT_ROUTES } from "../../../config/rolePermissions";
          const { DEFAULT_ROUTES } = require("../../../config/rolePermissions");
          const roleName = response?.role_name;
          console.log("Navigation logic - roleName:", roleName);
          console.log("Full response data:", response);
          const defaultRoute = DEFAULT_ROUTES[roleName] || "/dashboard";
          if (roleName) {
            this.props.navigate(defaultRoute);
          } else {
            console.log("No role found, navigating to default");
            this.props.navigate("/dashboard");
          }

          this.setState({ isLoadingDots: false });
        } else {
          // ✅ Handle login failure
          console.log("❌ Login Failed");
          const errorMessage = resultAction.payload || "Login failed. Please check your credentials.";
          this.setState({
            isLoadingDots: false,
            error: errorMessage,
          });
        }
      } catch (error) {
        console.error("❌ Login error:", error);
        this.setState({
          isLoadingDots: false,
          error: "An error occurred during login. Please try again.",
        });
      }
    }
  };

  render() {
    const { login_form } = this.state;
    const { loginLoading, UserData } = this.props;

    // ✅ This will be undefined initially, populated after login
    if (UserData) {
      console.log("Render - UserData exists:", UserData);
    }

    return (
      <React.Fragment>
        {loginLoading ? (
          <Loader />
        ) : (
          <div
            style={{ backgroundColor: `#FFF4E5` }}
            className="flex justify-center min-h-screen"
          >
            <div className="min-h-screen justify-center flex py-12 px-6">
              <div className="flex-col items-center justify-center flex">
                <div className="flex items-center mb-6">
                  <img className="brand-img" src={logoImage} alt="conserve" />
                </div>

                <Heading className="text-center mb-3">
                  Log in to your account
                </Heading>
                <p className="font-lato font-medium text-base leading-[1.5] text-center text-[#475467] mb-[28px]">
                  Welcome back! Please enter your details.
                </p>

                <Card className="bg-white w-500 rounded-xl block-shadow w-100 mt-2 px-10 py-8">
                  <div className="w-full">
                    <form onSubmit={this.loginSubmitHandler}>
                      {/* Display error message */}
                      {this.state.error && (
                        <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded text-sm">
                          {this.state.error}
                        </div>
                      )}

                      {/* Email Field */}
                      <div className="mb-5">
                        <label
                          className="block mb-[10px] font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] text-start"
                          htmlFor="Email"
                        >
                          Email
                        </label>
                        <div className="input-wrapper">
                          <input
                            className="input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border w-full py-2 px-3 pr-8 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="email"
                            type="email"
                            placeholder={login_form.email.placeholder}
                            value={login_form.email.value.trim()}
                            onChange={(e) => this.inputChangeHandler(e, "email")}
                            onPaste={(e) => {
                              e.preventDefault();
                              const pasteData = (
                                e?.clipboardData || window?.clipboardData
                              )?.getData("text");
                              this.inputChangeHandler(
                                { target: { value: pasteData?.trim() } },
                                "email"
                              );
                            }}
                          />
                          <div className="input-suffix-start right-set">
                            <span className="cursor-pointer">
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <g clipPath="url(#clip0_8475_89398)">
                                  <path
                                    d="M6.06016 5.99967C6.2169 5.55412 6.52626 5.17841 6.93347 4.9391C7.34067 4.69978 7.81943 4.6123 8.28495 4.69215C8.75047 4.772 9.17271 5.01402 9.47688 5.37536C9.78106 5.7367 9.94753 6.19402 9.94683 6.66634C9.94683 7.99967 7.94683 8.66634 7.94683 8.66634M8.00016 11.333H8.00683M14.6668 7.99967C14.6668 11.6816 11.6821 14.6663 8.00016 14.6663C4.31826 14.6663 1.3335 11.6816 1.3335 7.99967C1.3335 4.31778 4.31826 1.33301 8.00016 1.33301C11.6821 1.33301 14.6668 4.31778 14.6668 7.99967Z"
                                    stroke="#98A2B3"
                                    strokeWidth="1.33333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </g>
                              </svg>
                            </span>
                          </div>
                        </div>
                        {!login_form.email.valid && (
                          <div className="error field-error text-red-600 text-xs mt-1">
                            {login_form.email.error_msg}
                          </div>
                        )}
                      </div>

                      {/* Password Field */}
                      <div className="mb-6">
                        <label
                          className="block mb-[10px] font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] text-start"
                          htmlFor="password"
                        >
                          Password
                        </label>
                        <div className="input-wrapper">
                          <input
                            className="input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border w-full py-2 px-3 pr-8 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="password"
                            type={this.state.hiddenpassword ? "password" : "text"}
                            placeholder="••••••••"
                            value={login_form.password.value}
                            onChange={(e) => this.inputChangeHandler(e, "password")}
                          />
                          <div className="input-suffix-start right-set">
                            <span
                              className="gray-svg cursor-pointer"
                              onClick={this.togglePassword}
                            >
                              {this.state.hiddenpassword ? (
                                <svg
                                  stroke="currentColor"
                                  fill="none"
                                  strokeWidth="2"
                                  viewBox="0 0 24 24"
                                  height="21"
                                  width="20"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                                  ></path>
                                </svg>
                              ) : (
                                <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
                                  <path
                                    d="M2.017 11.094c-.114-.18-.17-.27-.202-.408a.977.977 0 0 1 0-.372c.032-.139.088-.229.202-.408.938-1.485 3.73-5.24 7.983-5.24 4.255 0 7.046 3.755 7.984 5.24.113.18.17.27.202.408a.976.976 0 0 1 0 .372c-.032.139-.089.229-.202.408-.938 1.485-3.73 5.24-7.984 5.24s-7.045-3.755-7.983-5.24z"
                                    stroke="#98A2B3"
                                    strokeWidth="1.667"
                                  />
                                  <path
                                    d="M10 13a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
                                    stroke="#98A2B3"
                                    strokeWidth="1.667"
                                  />
                                </svg>
                              )}
                            </span>
                          </div>
                        </div>
                        {!login_form.password.valid && (
                          <div className="error field-error text-red-600 text-xs mt-1">
                            {login_form.password.error_msg}
                          </div>
                        )}
                      </div>

                      {/* Remember Me & Forgot Password */}
                      <div className="flex items-center mb-6 justify-between">
                        <label className="block flex items-center cursor-pointer">
                          <input
                            className="w-4 h-4 mr-2 border border-gray-300 rounded bg-gray-50 focus:ring-0"
                            type="checkbox"
                            checked={login_form.remember.isChecked}
                            onChange={(e) => this.inputChangeHandler(e, "remember")}
                          />
                          <span className=" text-base leading-[1.5] text-[#344054]">
                            Remember me 
                          </span>
                        </label>
                        <Link
                          to="/forgot-password"
                          className={`inline-block font-lato not-italic font-medium text-[14px] leading-[150%] text-[#FF8E1C] hover:text-[#FF8E1C] ${
                            this.state.isLoadingDots && "pointer-events-none opacity-50"
                          }`}
                        >
                          Forgot Password
                        </Link>
                      </div>

                      {/* Submit Button */}
                      <div className="flex items-center justify-between w-100">
                        <BtnPrimary
                          disabled={this.state.isLoadingDots}
                          type="submit"
                          className="w-full"
                        >
                          {this.state.isLoadingDots ? <ThreeDotLoader /> : "Sign in"}
                        </BtnPrimary>
                      </div>
                    </form>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

// ✅ HOC to connect class component with Redux
function withReduxAndRouter(Component) {
  return function WrappedComponent(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loginLoading = useSelector(selectLoginLoading);
    const loginError = useSelector(selectLoginError);
    const UserData = useSelector(selectUserData);

    return (
      <Component
        {...props}
        dispatch={dispatch}
        navigate={navigate}
        loginLoading={loginLoading}
        loginError={loginError}
        UserData={UserData}
      />
    );
  };
}

export default withReduxAndRouter(Login);